import { render, staticRenderFns } from "./ItemsAutocomplete.vue?vue&type=template&id=43962d83"
import script from "./ItemsAutocomplete.vue?vue&type=script&lang=js"
export * from "./ItemsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports